import {Elements} from '@/types/theme';
import store from "@/store";
import {snapshot} from "valtio";

const sortElements = (items: Elements[] | null): Elements[] => {
    let inlineItem: Elements[]


    if (!items) {
        const {selectedTheme} = snapshot(store);
        const theme = JSON.parse(JSON.stringify(selectedTheme));
        const {currentElements} = theme;
        inlineItem = currentElements ? currentElements : [];
    } else {
        inlineItem = items;
    }


    inlineItem.sort((a, b) => {

        if (a.pinned && !b.pinned) return -1;
        if (!a.pinned && b.pinned) return 1;

		if (a.name === 'Main Css') return -1;
        if (b.name === 'Main Css') return 1;

	    if (a.name === 'Tour Steps') return -1;
	    if (b.name === 'Tour Steps') return 1;
        return a.name.localeCompare(b.name);
    });

    if (!items) {
        store.selectedTheme.currentElements = inlineItem;
    }

    return inlineItem;
};


export default sortElements;